import { render, staticRenderFns } from "./IMG.vue?vue&type=template&id=569e4db7&scoped=true&"
import script from "./IMG.vue?vue&type=script&lang=js&"
export * from "./IMG.vue?vue&type=script&lang=js&"
import style0 from "./IMG.vue?vue&type=style&index=0&id=569e4db7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569e4db7",
  null
  
)

export default component.exports